module.exports = __webpack_public_path__ + "img/price-tag.90127bb8.svg";